import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustBadges from "@/components/landing/TrustBadges";
import ProblemSection from "@/components/landing/ProblemSection";
import SolutionSection from "@/components/landing/SolutionSection";
import HowItWorks from "@/components/landing/HowItWorks";
import LiveDemo from "@/components/landing/LiveDemo";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Testimonials from "@/components/landing/Testimonials";
import ProofSection from "@/components/landing/ProofSection";
import FAQ from "@/components/landing/FAQ";
import LeadFormSection from "@/components/landing/LeadFormSection";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";

export default function LandingPage() {
  return (
    <main className="relative" data-testid="landing-page">
      <div className="fixed inset-0 -z-10 bg-animated-grid" aria-hidden="true" />
      <div className="fixed inset-0 -z-10 bg-grid-lines opacity-60" aria-hidden="true" />
      <Header />
      <Hero />
      <TrustBadges />
      <ProblemSection />
      <SolutionSection />
      <HowItWorks />
      <LiveDemo />
      <BeforeAfter />
      <Testimonials />
      <ProofSection />
      <FAQ />
      <LeadFormSection />
      <FinalCTA />
      <Footer />
      <StickyCTA />
    </main>
  );
}
